import { HeaderDetails } from '../../../../pt-core/src/lib/header-details';

export abstract class AbstractEntityDetailPage<T> {
  abstract getHeaderDetails(): HeaderDetails;
  abstract getEntityDetails(): T;

}
